import { Divider, Drawer, Grid, List, ListItem } from '@mui/material';
import React, { useContext } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import './riskbar.scss';
import ProjectWarningContext from '../../context/ProjectWarningContext';

const RiskBarDrawer = () => {
  const { dispatch: clickDispatch, projectWarnings } = useContext(ProjectWarningContext);

  const hideRiskBar = async () => {
    await clickDispatch({
      type: 'SHOW_RISK_BAR',
      payload: {
        showRiskBar: false,
      },
    });
  };

  return (
    <Grid item className="transition-class">
      <div>
        <Drawer className="notification-sidebar" variant="permanent" anchor="right">
          <CloseOutlinedIcon className="closeButton" onClick={hideRiskBar} />

          <Grid className="alertTitle">Alerts</Grid>
          <Divider sx={{ mt: '124px' }} />
          <List>
            {projectWarnings.length === 0 ? (
              <ListItem className="listItem">No Alerts</ListItem>
            ) : (
              <>
                {projectWarnings.map((dataItem) => (
                  <ListItem
                    key={dataItem.id}
                    className={
                      dataItem.warning_type === 'SKILL'
                        ? 'listItem skill'
                        : 'listItem crossProjectAllocation'
                    }
                  >
                    {dataItem.warning_type === 'SKILL' ? (
                      <span>
                        {dataItem.warning_message.substring(
                          0,
                          dataItem.warning_message.indexOf(':') + 1,
                        )}
                        <span className="boldFont">
                          {dataItem.warning_message.substring(
                            dataItem.warning_message.indexOf(':') + 1,
                          )}
                        </span>
                      </span>
                    ) : (
                      <span>
                        <span className="boldFont">
                          {dataItem.warning_message.substring(
                            0,
                            dataItem.warning_message.indexOf(
                              ' ',
                              dataItem.warning_message.indexOf(' ') + 1,
                            ) + 1,
                          )}
                        </span>
                        {dataItem.warning_message.substring(
                          dataItem.warning_message.indexOf(
                            ' ',
                            dataItem.warning_message.indexOf(' ') + 1,
                          ) + 1,
                        )}
                      </span>
                    )}
                  </ListItem>
                ))}
              </>
            )}
          </List>
        </Drawer>
      </div>
    </Grid>
  );
};

export default RiskBarDrawer;
